var _path, _path2, _line, _line2, _line3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorReceptionDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.587,25.801v-8.794c0-2.031-1.606-3.674-3.615-3.761-1.266,1.43-3.094,2.349-5.153,2.349s-3.888-.92-5.154-2.349c-2.009.087-3.615,1.73-3.615,3.761v8.794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.072,39.031v-9.26h.932c1.096,0,1.985-.889,1.985-1.985h0c0-1.096-.889-1.985-1.985-1.985H7.996c-1.096,0-1.985.889-1.985,1.985h0c0,1.096.889,1.985,1.985,1.985h1.048v9.26"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.836,
    y1: 25.522,
    x2: 16.836,
    y2: 19.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.723,
    y1: 25.522,
    x2: 24.723,
    y2: 19.44
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.044,
    y1: 29.771,
    x2: 33.072,
    y2: 29.771
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.69,
    cy: 7.412,
    r: 4.443
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorReceptionDesk);
export default __webpack_public_path__ + "static/media/indoor-reception_desk.7109f3fadae314fa454cee7245a83dc6.svg";
export { ForwardRef as ReactComponent };